export type ConfidenceChipColor =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning';

/**
 * MUI Chip `color` for a confidence level ("high" / "medium" / "low" /
 * "very_low", any case). Returns a colour name, not a theme path.
 */
export const confidenceColor = (level?: string | null): ConfidenceChipColor => {
  if (!level) return 'default';

  switch (level.toLowerCase()) {
    case 'high':
      return 'success';
    case 'medium':
      return 'warning';
    case 'low':
    case 'very_low':
      return 'error';
    default:
      return 'default';
  }
};
